// rbtProgramPagination,
// programSearch,
// rbtProgramGetFormData,

//Home Widget Search //
export const widgetColClick = (e) => {
    //get button and pane
    let bttn = e.target.tagName == 'BUTTON' ? e.target : e.target.closest('BUTTON');
    let choices = bttn.nextElementSibling;
    let pane = choices ? choices.querySelector('ul.pane') : false;
    let root = bttn.closest('section#program-search');

    if (!choices || !pane || !root) return false;

    let activeChoices = root.querySelectorAll('.choices.active');
    let activePanes = root.querySelectorAll('.pane.active');
    // collapse the active panes/choices that aren't this column (or toggle off if the clicked column is active)
    let toggleOff = false;
    for (let aChoice of activeChoices) {
        if (aChoice === choices) toggleOff = true;
        aChoice.classList.remove('active');
    }
    for (let aPane of activePanes) {
        aPane.classList.remove('active');
    }
    // if we aren't toggling off, make the new column active
    if (!toggleOff) {
        choices.classList.add('active');
        pane.classList.add('active');
    }

}

export const secondColumnClick = (e) => {
    let bttn = e.target.tagName === 'BUTTON' ? e.target : e.target.closest('BUTTON');
    let root = bttn.closest('section#program-search');

    if (!bttn || !root) return false;

    let whoSelected = root.querySelector('.col-1 button.set-tax-button').getAttribute('data-selected-choice');
    let choices = bttn.nextElementSibling;
    if (!choices) return false;

    let panes = choices.querySelectorAll('ul.pane');
    for (let pane of panes) {
        pane.classList.remove('active');
        // Show pane if it matches the dependency or fallback
        if (pane.dataset.taxWho === whoSelected || pane.classList.contains('fallback')) {
            pane.classList.add('active');
        }
    }

    choices.classList.add('active');
};

export const setWidgetTax = (e) => {
    let li = e.target.tagName === 'LI' ? e.target : e.target.closest('LI');
    const eventChoice = li.getAttribute('data-choice');
    const eventTaxTerm = li.getAttribute('data-tax-term');
    let choices = li.closest('.choices');
    let taxonomy = choices ? choices.id.replace('choices-', '') : false;
    let bttn = choices ? choices.previousElementSibling : false;

    if (!bttn || !eventChoice || !eventTaxTerm) {
        console.error("Error in setWidgetTax: Missing required attributes.");
        return false;
    }

    // Update button state for the selected column
    bttn.setAttribute('data-selected-tax', eventTaxTerm);
    bttn.setAttribute('data-selected-choice', eventChoice);
    bttn.classList.remove('unset');
    bttn.innerHTML = li.innerHTML;

    // Update formwrap data attributes
    let attName = 'data-' + taxonomy;
    let wrap = bttn.closest('.formwrap');
    wrap.setAttribute(attName, eventChoice);

    // If the "Who" column was updated, reset the "What" column and disable the "Go" button
    if (taxonomy === 'who') {
        let whatButton = wrap.querySelector('.col-2 button.set-tax-button');
        let whatChoices = wrap.querySelector('#choices-what');

        // Reset "What" column button and choices
        whatButton.setAttribute('data-selected-tax', '');
        whatButton.setAttribute('data-selected-choice', '');
        whatButton.classList.add('unset');
        whatButton.innerHTML = 'Choose';
        whatChoices.querySelectorAll('.pane').forEach((pane) => pane.classList.remove('active'));

        // Reset formwrap attribute for "What"
        wrap.setAttribute('data-what', '');

        // Disable "Go" button
        let goButton = wrap.querySelector('.col-3 button.main');
        if (goButton) goButton.disabled = true;
        if (goButton) goButton.setAttribute('data-url', '');
    }

    closeAllPanels(wrap);
    doHomeWidgetTick(wrap);
};

const closeAllPanels = (root) => {
    let activeChoices = root.querySelectorAll('.choices.active');
    let activePanes = root.querySelectorAll('.pane.active');
    for (let choice of activeChoices) choice.classList.remove('active');
    for (let pane of activePanes) pane.classList.remove('active');
}

const doHomeWidgetTick = (root) => {
    if (!root.classList.contains('formwrap')) console.error("did not pass root to doHomeWidgetTick");
    const who = root.getAttribute('data-who');
    const what = root.getAttribute('data-what');
    const button = root.querySelector('.col-3 button.main');

    if (who.length && what.length) {
        const whoButton = root.querySelector('.col-1 button.set-tax-button');
        const whatButton = root.querySelector('.col-2 button.set-tax-button');
        let url = '/programs/' + whoButton.getAttribute('data-selected-tax') + '/' + whatButton.getAttribute('data-selected-tax') + '/';

        /* special cases */
        switch (url) {
            case ('/programs/adult/high-school-abroad/'):
                url = '/greenheart-parent-handbook';
                break;
            case ('/programs/adult/groups/'):
                url = '/greenheart-group-trips/';
                break;
            case ('/programs/teen/first-time-traveler/'):
                url = '/scholarships/';
                break;
            default: break;
        }
        if (button) {
            button.disabled = false;
            button.setAttribute('data-url', url);
        } else {
            const full_url = window.location.origin + url;
            window.location.href = full_url;
        }

    } else {
        if (button) {
            button.disabled = 'disabled';
            button.setAttribute('data-url', '');
        }

    }

}

export const setProgramsPaging = (event) => {
    event.preventDefault();
    const element = event.target.tagName === 'A' ? event.target : event.target.closest('A');
    const page = element.getAttribute('data-page');
    const root = element.closest('[data-process="rbtProgramsQuery"]');

    if (!root || !page) {
        console.error('Missing required elements for pagination');
        return;
    }

    root.setAttribute('data-page', page);
    rbtProgramsQuery(root, false);
};

export const widgetGo = (e) => {
    let bttn = e.target.tagName === 'BUTTON' ? e.target : e.target.closest('BUTTON');
    let url = bttn.getAttribute('data-url');
    if (url) {

        let fullUrl = window.location.origin + url;
        window.location.href = fullUrl
    }
}

//end homepage widget

/* Main Search */
export const rbtProgramsQuery = async (item, ignorePagination = true) => {

    /* Need to populate the results portion of the rbtQuery form with the default */
    if (item.getAttribute('data-process') !== 'rbtProgramsQuery') item = item.closest('[data-process="rbtProgramsQuery"]');

    const displaycontainer = item.querySelector('.rbt-query-results-wrap');
    const form = item.querySelector('.rbt-query-form-wrap form');
    const target = item.querySelector('.rbt-query-results-wrap');


    const loader = `<span class="rbt-loader">
                        <svg version="1.1" id="Layer_1" class="loader" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 53.2 50" style="enable-background:new 0 0 53.2 50;">
                            <style type="text/css">.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#00843D;}.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFD100;}</style>
                            <g><path class="st0" d="M26.6,8.5C28.5,5.2,30.9,3,34,1.8c1.9-0.8,3.8-1.1,5.5-1c1.9,0.1,4,0.3,6,1.3c2.1,1.1,3.6,2.8,4.7,4.5 c1.1,1.6,1.8,3.6,2.1,6.1c0.3,2.5,0.1,4.6-0.5,6.5c-0.6,1.8-1.4,3.5-2.4,5.1c-0.9,1.6-2.2,3.1-3.7,4.7c-0.9,0.9-2.4,2.3-4.4,4.1 c-0.9,0.8-2.4,2.1-4.5,3.9c-1.8,1.5-3.1,2.7-4,3.5c-2.4,2.2-4.5,4.7-6.3,7.4c-1.7-2.7-3.8-5.2-6.2-7.4c-0.9-0.8-2.2-2-4-3.5 c-1.5-1.3-3-2.6-4.4-3.9c-2-1.8-3.5-3.2-4.4-4.1c-1.5-1.5-2.8-3.1-3.7-4.7c-1-1.6-1.8-3.3-2.4-5.1c-0.6-1.8-0.8-4-0.5-6.5 c0.3-2.5,1-4.5,2.1-6.1c1.1-1.6,2.2-3,4.4-4.1c2-1,4.4-1.6,6.3-1.7c1.8-0.1,3.6,0.3,5.5,1C22.3,3,24.8,5.2,26.6,8.5"/><path class="st1" d="M14.2,1.6c-0.2,0-0.3,0-0.5,0c-1.9,0.1-4.2,0.7-6,1.6c-1.9,1-3,2.2-4.1,3.8c-1,1.5-1.7,3.4-1.9,5.8 c-0.3,2.3-0.1,4.4,0.5,6.1c0.6,1.7,1.4,3.4,2.3,5c0.9,1.5,2.1,3.1,3.6,4.5c0.8,0.9,2.2,2.2,4.4,4.1c0.9,0.8,2.3,2.1,4.4,3.8 c1.8,1.5,3.1,2.7,4,3.5c2.1,2,4.1,4.2,5.7,6.6c1.7-2.4,3.6-4.6,5.7-6.6c0.9-0.9,2.3-2.1,4-3.5c1.5-1.3,3-2.5,4.4-3.8 c1.9-1.7,3.4-3.1,4.4-4.1c1.5-1.5,2.7-3.1,3.6-4.5c0.9-1.6,1.7-3.2,2.3-5c0.6-1.7,0.8-3.8,0.5-6.1c-0.3-2.4-0.9-4.3-1.9-5.8 c-1.3-2-2.8-3.3-4.4-4.2c-1.8-1-3.8-1.2-5.6-1.2c-0.1,0-0.3,0-0.5,0c-1.6,0-3.2,0.3-4.8,1c-2.9,1.1-5.3,3.3-7,6.4l-0.7,1.2 l-0.7-1.2c-1.8-3.1-4.1-5.2-7-6.4C17.3,1.9,15.7,1.6,14.2,1.6z M26.6,49.3l-0.7-1c-1.7-2.7-3.8-5.1-6.1-7.3c-0.9-0.8-2.2-2-4-3.5 c-1.5-1.3-3-2.6-4.5-3.9c-2.2-1.9-3.6-3.2-4.5-4.1c-1.5-1.6-2.8-3.2-3.8-4.8c-1-1.7-1.8-3.4-2.4-5.3c-0.7-2-0.9-4.2-0.6-6.8 c0.3-2.6,1-4.8,2.2-6.5C3.5,4.4,4.8,3,7,1.8c1.9-1,4.5-1.7,6.6-1.8c1.9-0.1,3.9,0.3,5.9,1c2.9,1.1,5.3,3.1,7.1,5.9 c1.8-2.8,4.2-4.8,7.1-5.9c2-0.8,3.9-1.1,5.9-1.1c2,0.1,4.2,0.3,6.3,1.4c1.9,1,3.5,2.5,5,4.7c1.2,1.7,1.9,3.9,2.2,6.5 c0.3,2.6,0.1,4.9-0.6,6.8c-0.7,1.9-1.5,3.6-2.4,5.3c-0.9,1.6-2.2,3.2-3.8,4.8c-1,1-2.5,2.4-4.5,4.1c-1,0.9-2.5,2.2-4.5,3.9 c-1.7,1.4-3,2.6-4,3.5c-2.4,2.2-4.4,4.6-6.1,7.3L26.6,49.3L26.6,49.3z"/> </g>
                        </svg>
                    </span>`;

    target.innerHTML = loader;

    if (!form || !form.hasAttribute('data-post_type')) {
        console.log("rbtProgamQuery skipped, no form or post_type attribute");
        return;
    }

    const dataAttributes = form.dataset;
    let itemData = item.dataset;
    if (itemData.hasOwnProperty.perPage) {
        itemData.postsPerPage = itemData.perPage;
    }

    //preselected
    let preselected = new FormData(form);
    preselected = Array.from(preselected.entries()).map(([key, value]) => ({ [key]: value }));
    preselected = Object.assign({}, ...preselected);
    //const selected = getButtonData(item);
    const queryObject = Object.assign({}, itemData, { "selected": dataAttributes }, { "preselected": preselected });

    console.log("queryObject", queryObject);



    /* When a control (other than page forward or back) is changed we want to reset the pagination to 1 */
    if (false === ignorePagination) {
        queryObject.paged = item.getAttribute('data-page');
        console.log("Paged", queryObject.paged);
    } else {
        queryObject.paged = 1;
    }

    let url = rbtQD.apiBase + 'programs/filter/';
    let nonce = rbtQD.nonce;

    try {
        const response = await rbtSendDisplayRequest(url, queryObject, nonce);
        if (response) queryHandleResponse(response);

    } catch (error) {
        console.error('Error fetching data:', error);
    }
}

const rbtSendDisplayRequest = async (url, queryobject, nonce) => {

    let response = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-WP-Nonce': nonce
        },
        body: JSON.stringify(queryobject)
    });
    if (response.ok) {
        console.log(response);
        return await response.json();
    } else {
        throw new Error(response.status);
    }

}
const queryHandleResponse = (response) => {
    console.log("Handling Response PROGRAM");
    /* Set filters */
    populateFilters(response.response.formFilters);
    /* Set results */
    populateResults(response.response);
    console.log("Handling Response");
    console.log(response.response);
}

const slugToTitleCase = (slug) => {
    let phrase = slug.replace(/-/g, ' ');
    return phrase.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
}



export const mapPickRegion = (e) => {
    const region = e.target.classList.contains('region') ? e.target : e.target.closest('.region');
    if (region.classList.contains('disabled')) return;
    const svg = region.closest('SVG');
    const regions = svg.querySelectorAll('.region');
    const root = svg.closest('div[data-handle="programswidget"]');
    const form = root.querySelector('form');
    const column = root.querySelector('.col.col-region');
    const controlButton = column ? column.querySelector('button.form-control') : false;

    if (!controlButton) return;

    let caseUnset = false;
    /* set active class on map */
    for (let r of regions) {
        if (r.id === region.id) {
            if (r.classList.contains('active')) {
                //unset case - remove active class from region
                r.classList.remove('active');
                caseUnset = true;
            } else {
                //normal case - set new region to active
                r.classList.add('active');
            }

        } else {
            r.classList.remove('active');

        }
    }
    /* update state on button */
    controlButton.dataset.selected = caseUnset ? '' : region.id;
    const niceName = caseUnset ? 'Choose' : slugToTitleCase(region.id);
    controlButton.innerHTML = niceName;
    document.querySelectorAll('.choices.active').forEach(pane => pane.classList.remove('active'));
    resetWaitingControls(root, controlButton.dataset.taxName);
    const selected = getButtonData(root);
    // Normalize input into an array of key-value pairs 
    const keyValuePairs = Array.isArray(selected)
        ? selected.flatMap(Object.entries)
        : Object.entries(selected);

    // Iterate over the key-value pairs and update the dataset
    keyValuePairs.forEach(([key, value]) => {
        if (key in form.dataset) {
            form.setAttribute(`data-${key}`, value);
        }
    });
    if (caseUnset) {
        //unset the toggled off region taxonomy value
        form.setAttribute('data-region', '');
    }

    programsWidgetTick(root);
}

const populateResults = (apiResponse) => {
    const widgetHandle = apiResponse.formFilters.handle;
    const widgetElement = document.querySelector(`[data-handle="${widgetHandle}"]`);
    console.log("widgetElement", widgetElement);
    if (!widgetElement) return;

    const resultsElement = widgetElement.querySelector(".rbt-query-results-wrap");

    if (!resultsElement) return;

    // Clear existing results
    resultsElement.innerHTML = apiResponse.displayHTML;
}
const getWaitingMessage = (waitFor) => {
    const map = {
        'region': 'Please select a region first',
        'country': 'Please select a country first',
        'who': 'Please tell us who you are',
        'what': 'Please tell us what you want to do',
    }
    return map[waitFor];
}

const populateFilters = (apiResponse) => {
    console.log("RESPONSE", apiResponse);
    const widgetHandle = apiResponse.handle;
    const widgetElement = document.querySelector(`[data-handle="${widgetHandle}"]`);

    if (!widgetElement) return;

    const formElement = widgetElement.querySelector("form");

    // Populate options for each control
    function populateControl(controlName, options, selected, preselected) {

        console.log("Populating control for ", controlName);
        console.log("Options", options);
        console.log("Selected", selected);
        console.log("Preselected", preselected);
        const controlButton = formElement.querySelector(`.set-tax-button[data-tax-name="${controlName}"]`);
        const choicesElement = widgetElement.querySelector(`#choices-${controlName}`);

        const column = controlButton ? controlButton.closest('.col') : null;
        const controlWaitsFor = column ? column.getAttribute('data-wait-for') : null;
        const controlHidesUntil = column ? column.getAttribute('data-hide-until') : null;

        if (!controlButton) return;
        if (!choicesElement) return;


        if (controlHidesUntil) {
            const hideUntil = controlHidesUntil.includes(',')
                ? controlHidesUntil.split(',').map(dep => dep.trim())
                : [controlHidesUntil]; // Ensure it's always an array
            let hiding = false;
            for (const dep of hideUntil) {
                if (!selected.hasOwnProperty(dep) || selected[dep] === '' || selected[dep] === 'null') {
                    //we are waiting for an unset dependency...is is preset?
                    if (preselected) continue;

                    hiding = dep;
                    console.log(`Hiding until dependency is met: ${dep}`);
                    break; // Exit loop if any dependency is unmet
                }
            }
            if (hiding) {
                column.classList.add('hidden');
            } else {
                column.classList.remove('hidden');
            }
        }



        if (controlWaitsFor) {

            const dependencies = controlWaitsFor.includes(',')
                ? controlWaitsFor.split(',').map(dep => dep.trim())
                : [controlWaitsFor]; // Ensure it's always an array

            if (controlName === "region") {
                console.log("region controlWaitsFor", dependencies);
                console.log("selected", selected);
            }
            let waiting = null;

            for (const dep of dependencies) {
                // Check if dependency is unmet
                // For some reason I'm getting a text null...json conversion issue?
                if (!selected.hasOwnProperty(dep) || selected[dep] === '' || selected[dep] === 'null') {
                    //we are waiting for an unset dependency...is is preset?
                    if (preselected) continue;

                    //unmet dependency
                    waiting = dep;
                    console.log(`Waiting for unmet dependency: ${dep}`);
                    break; // Exit loop if any dependency is unmet
                }
            }

            if (waiting) {
                if (choicesElement) {
                    choicesElement.innerHTML = `<ul class="pane" data-tax="${controlName}"><li>${getWaitingMessage(waiting)}</li></ul>`;
                }
                return; // Exit early since a dependency is unmet
            }
        }

        // if (!controlButton || !choicesElement || !options || !dependenciesMet(controlButton)) {
        //     if (choicesElement) choicesElement.innerHTML = ""; // Clear options if dependencies are unmet
        //     return;
        // }

        // Clear existing choices
        const ulPane = choicesElement.querySelector(".pane");

        if (!ulPane || !options) return;

        // Add new options
        ulPane.innerHTML = "";
        options.forEach(option => {
            const li = document.createElement("li");
            const inner = option.icon ? `<img class="home-widget-icon" src="${option.icon}" alt="${option.label}" />` : false;
            let text = inner ? `<span>${inner} ${option.label}</span>` : option.label;
            //li.textContent = option.label;
            li.setAttribute("onclick", "setTaxTerm(event)");
            li.setAttribute("data-tax-term", option.value);
            li.innerHTML = text;

            // Mark as active if in the selected array
            if (selected && selected[controlName] && selected[controlName] == option.value) {
                li.classList.add("active");
                controlButton.innerHTML = li.innerHTML; // Update button label and icon
                controlButton.setAttribute("data-selected", option.value);
                controlButton.classList.remove("unset");
            }

            ulPane.appendChild(li);
        });


        // Handle preselected values
        if (preselected && !controlButton.getAttribute("data-selected")) {
            controlButton.setAttribute("data-selected", preselected);
            const preselectedOption = options.find(option => option.value === preselected);
            if (preselectedOption) {
                controlButton.textContent = preselectedOption.label;
                controlButton.classList.remove("unset");
            }
        }
    }
    console.log(apiResponse);

    const preselected = new FormData(formElement);
    const selected = formElement.dataset;

    // Populate each filter
    populateControl("who", apiResponse.whoOptions, selected, preselected.get('who'));
    populateControl("what", apiResponse.whatOptions, selected, preselected.get('what'));
    populateControl("region", apiResponse.regionOptions, selected, preselected.get('region'));
    populateControl("country", apiResponse.countryOptions, selected, preselected.get('country'));
    populateControl("season", apiResponse.seasonOptions, selected, preselected.get('season'));
    populateControl("duration", apiResponse.durationOptions, selected, preselected.get('duration'));
};

const resetWaitingControls = (root, waitFor) => {
    if (!root) {
        console.error("Root element is null or undefined.");
        return;
    }

    const allWaitFors = root.querySelectorAll(`[data-wait-for]`);
    allWaitFors.forEach(waitCol => {
        let wait = waitCol.getAttribute('data-wait-for');
        if (wait === null) {
            console.warn("Element missing 'data-wait-for':", waitCol);
            return;
        }

        let match = false;
        if (wait.indexOf(',') > -1) {
            let waitArr = wait.split(',');
            match = waitArr.includes(waitFor);
        } else {
            match = wait === waitFor;
        }

        if (!match) return;

        const pane = waitCol.querySelector('.pane');
        if (!pane) {
            console.warn("Pane element not found for:", waitCol);
            return;
        }

        let active = pane.querySelectorAll('li.active');
        active.forEach(li => { li.classList.remove('active'); });

        const waitButton = waitCol.querySelector('.set-tax-button');
        if (waitButton) {
            unsetButton(waitButton);
        } else {
            console.warn("Button not found for:", waitCol);
        }
    });
};

export const programTaxClick = (event) => {
    event.preventDefault();
    const currentButton = event.target;

    const choicesContainer = currentButton.dataset.taxName === "region" ? document.querySelector("#choices-region") : currentButton.closest('.form-ctrl-wrap').querySelector('.choices');

    // Remove the .active class from all ul.pane elements
    document.querySelectorAll('.choices').forEach(pane => pane.classList.remove('active'));


    // Add the .active class to the relevant pane
    if (choicesContainer) {
        choicesContainer.classList.add('active');
    }
}

export const setTaxTerm = (event) => {
    const selectedLi = event.target.tagName === 'LI' ? event.target : event.target.closest('li');
    const root = selectedLi.closest('.rbt-query-form-wrap');
    const form = root.querySelector('form');
    const pane = selectedLi.closest('.pane');
    const columnTaxonomy = pane ? pane.dataset.tax : false;

    if (!columnTaxonomy) return;

    const column = root.querySelector('.col-' + columnTaxonomy);
    const controlButton = column ? column.querySelector('button.form-control') : false;

    if (!controlButton) return;

    // Update the button with the selected taxonomy term
    controlButton.dataset.selected = selectedLi.dataset.taxTerm;
    controlButton.classList.remove('unset');
    controlButton.innerHTML = selectedLi.innerHTML;

    //match button heights
    setButtonHeight(root);

    // Remove the .active class from all ul.pane elements
    document.querySelectorAll('.choices.active').forEach(pane => pane.classList.remove('active'));

    //reset controls that wait for this control
    resetWaitingControls(root, controlButton.dataset.taxName);

    //update the form data-attributes
    const selected = getButtonData(root);

    // Normalize input into an array of key-value pairs 
    const keyValuePairs = Array.isArray(selected)
        ? selected.flatMap(Object.entries)
        : Object.entries(selected);

    // Iterate over the key-value pairs and update the dataset
    keyValuePairs.forEach(([key, value]) => {
        if (key in form.dataset) {
            form.setAttribute(`data-${key}`, value);
        }
    });

    programsWidgetTick(root);
}

export const rbtSelectProgram = (event) => {
    // Get the clicked list item and root component
    const listItem = event.target.tagName == 'LI' ? event.target : event.target.closest('li');
    const selectRoot = listItem.closest('.rbt-select');

    // Remove active class from the select root - choosing will always collapse the select
    selectRoot.classList.remove('active');

    //Update the active LI controls
    let icons = selectRoot.querySelectorAll('.rbt-select-icon');
    let theIcon = listItem.querySelector('.rbt-select-icon');

    for (let icon of icons) {
        if (icon === theIcon) {
            icon.classList.add('active');
        } else {
            icon.classList.remove('active');
        }
    }
    // Update the form dataset and Select text 
    const root = selectRoot.closest('.rbt-query');
    const form = root.querySelector('form');
    //const termID = listItem.getAttribute('data-value');
    const termSlug = listItem.getAttribute('data-slug');
    const hiddenInput = selectRoot.querySelector('input[type="hidden"]');
    const selectLabel = selectRoot.querySelector('.select-label');

    // Update the hidden input value
    hiddenInput.value = termSlug;
    selectLabel.textContent = listItem.textContent.trim();

    //update the form dataset
    const updateKey = hiddenInput.name;
    if (form.dataset[updateKey]) form.dataset[updateKey] = termSlug;

    programsWidgetTick(root);
}

const getButtonData = (root) => {
    const buttons = root.querySelectorAll('button.form-control');
    const selectedTaxonomies = [];
    buttons.forEach(button => {
        const taxName = button.dataset.taxName;
        const taxValue = button.dataset.selected;

        if (taxName && taxValue) {
            selectedTaxonomies.push({ [taxName]: taxValue });

            // Check for mismatched data attributes (edge case handling)
            if (taxName !== button.dataset.tax) {
                //region/country is top-level and child-level of taxonomy where
                console.warn(`Mismatch: ${taxName} !== ${button.dataset.tax}`);
                switch (taxName) {
                    case 'region':
                        if (taxValue) {
                            selectedTaxonomies.push({ 'region': taxValue });
                            break;
                        }

                    case 'country':
                        if (taxValue) {
                            selectedTaxonomies.push({ 'country': taxValue });
                            break;
                        }
                    default:
                        break;
                }
            }
        }
    });
    return selectedTaxonomies;
}

const setButtonHeight = (root) => {
    const buttons = root.querySelectorAll('button.form-control');
    let maxH = 0;
    for (let b of buttons) {
        if (b.offsetHeight > maxH) {
            maxH = b.offsetHeight;
        }
    }
    for (let b of buttons) {
        b.style.minHeight = maxH + 'px';
    }

}
export const rbtProgramSearch = (e) => {
    e.preventDefault();
    /* */
}
export const rbtProgramPagination = (e) => {
    e.preventDefault();
    const newpage = e.target.dataset.paged;
    const blockroot = e.target.closest('[data-process="rbtQuery"]');
    const formwrap = blockroot ? blockroot.querySelector('.rbt-query-form-wrap') : null;
    if (formwrap) {
        const form = formwrap.querySelector('form');
        form.setAttribute('data-paged', newpage);
        rbtQuery(blockroot, false);
    }
}

export const submitSearch = (e) => {
    e.preventDefault();
};
const unsetButton = (button) => {
    button.dataset.selected = null;
    button.innerHTML = 'Choose';
    button.classList.add('unset');
}

const programsWidgetTick = (root, ignorePagination = true) => {
    if (!root) return;

    const formTrigger = root.querySelector('.rbt-display-form-area')?.dataset?.formTrigger;

    if (!formTrigger) return;

    // if(!isValid) {
    //     // Disable the go button
    //     if(formTrigger && formTrigger === 'button') {
    //         const goButton = root.querySelector('.go-button');
    //         if(goButton) {
    //             goButton.disabled = true;
    //             goButton.classList.add('disabled');
    //         }
    //     }
    //     // This covers both fetch and button triggers - HERE IS A PROBLEM
    //     // You need to query more to get the filters you need to get results. 
    //     // for now we should just make everything valid and then iterate for UI of buttons
    //     return;
    // }

    // Data is valide, so we can enable the go button
    if (formTrigger === 'button') {
        const goButton = root.querySelector('.go-button'); // Update with the actual button selector
        if (goButton) {
            goButton.disabled = false;
            goButton.classList.remove('disabled');
        }
    }
    if (formTrigger === 'onchange') {
        // Call fetch function here
        const block = root.closest('[data-process="rbtProgramsQuery"]');
        if (block) {
            rbtProgramsQuery(block, ignorePagination);
        }
    }
}
export function rbtSelectToggle(event) {
    // Get the root component element
    const selectRoot = event.target.closest('.rbt-select');

    // Close all other select components
    document.querySelectorAll('.rbt-select').forEach(select => {
        if (select !== selectRoot) {
            select.classList.remove('active');
        }
    });

    // Toggle active state on the clicked component
    selectRoot.classList.toggle('active');
}

export function rbtSelectChoose(event) {
    // Get the clicked list item and root component
    const listItem = event.target.tagName == 'LI' ? event.target : event.target.closest('li');
    const selectRoot = listItem.closest('.rbt-select');
    const root = selectRoot.closest('.rbt-query-form-wrap');
    // Get the value from data attribute
    const selectedValue = listItem.getAttribute('data-value');

    // Find and update the hidden input
    const hiddenInput = selectRoot.querySelector('input[type="hidden"]');
    if (hiddenInput) {
        hiddenInput.value = selectedValue;
    }
    // Update the label
    const label = selectRoot.querySelector('.select-label');
    if (label) {
        label.textContent = listItem.textContent;
    }

    // Close all select components
    document.querySelectorAll('.rbt-select').forEach(select => {
        select.classList.remove('active');
    });

    doRbtSearch(event);
    //programsWidgetTick(root);
}

